
























import { computed, defineComponent, reactive } from '@vue/composition-api';
import { useQuery } from '@vue/apollo-composable';

import averageDeliveryTimeByArea from '@/gql/managementReport/04-DeliveryTime/averageDeliveryTimeByArea.gql';
import { NOW_YEAR } from '@/utils';
import {
  deliveryTimeColor,
} from '@/useDelivery';

import ChartWithMoneyAxis from '@/components/Vivat/Chart/ChartWithMoneyAxis.vue';

const AverageDeliveryTimeByArea = defineComponent({
  components: {
    ChartWithMoneyAxis,
  },
  props: {
    height: {
      type: String,
      default: '',
    },
  },
  setup() {
    const filter = reactive({
      year: {
        from: `${NOW_YEAR}-01-01`,
        to: `${NOW_YEAR}-12-31`,
      },
    });
    const { result, loading } = useQuery(averageDeliveryTimeByArea, computed(() => ({
      timeframe: filter.year,
    })));

    const getDataArray = computed(() => {
      if (loading.value === false) {
        return result.value.averageDeliveryTimeByArea;
      }
      return [];
    });
    // const labels = computed(() => ['สาขา 1', 'สาขา 2', 'สาขา 3', 'สาขา 4', 'สาขา 5']);
    const labels = computed(() => getDataArray.value?.map((item: any) => item.areaCode));
    const data = computed(() => getDataArray.value?.map((item: any) => item.amount));

    const plugins = {
      legend: {
        display: false,
      },
    };
    const chartData = computed(() => ({
      labels: labels.value,
      datasets: [
        {
          label: '',
          data: data.value,
          backgroundColor: (ctx: any) => {
            const index = ctx.dataIndex;
            const value: number = Math.floor(ctx.dataset.data[index]) || 1;
            if (value > 7) return deliveryTimeColor.day7;
            if (value > 3) return deliveryTimeColor.day4;
            return deliveryTimeColor[`day${value as (1 | 2 | 3)}`];
          },
        },
      ],
    }));

    return {
      filter,
      plugins,

      chartData,
    };
  },
});

export default AverageDeliveryTimeByArea;
